<xpo-footer xpoFooterSticky [version]="buildVersion">
  <div class="footer__actions">
    <a xpo-regular-link (click)="openHelpLink()" color="accent" data-test="footer__help">Help</a>
    <a xpo-regular-link [href]="getMailLink()" color="accent" data-test="footer__feedback">Feedback</a>
    <a xpo-regular-link (click)="releaseNotes.emit()" color="accent" date-test="footer__release-notes">Release Notes</a>
  </div>
</xpo-footer>
